import { Badge } from "@/components/ui/badge";
import type { VisualSeed, VisualNode } from "@/hooks/useMapVisualData";
import { ROLE_COLORS, ROLE_LABELS } from "./constants";

interface MapStatsCardsProps {
  seeds: VisualSeed[];
  nodes: VisualNode[];
}

export function MapStatsCards({ seeds, nodes }: MapStatsCardsProps) {
  const readyCount = nodes.filter(n => n.engine_stage === "ready" || n.engine_stage === "published").length;
  const pct = nodes.length > 0 ? Math.round((readyCount / nodes.length) * 100) : 0;

  // Count per role
  const roleCounts: Record<string, number> = {};
  for (const n of nodes) {
    roleCounts[n.document_role] = (roleCounts[n.document_role] || 0) + 1;
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="rounded-xl border bg-card p-4">
        <p className="text-xs text-muted-foreground">Seeds</p>
        <p className="text-2xl font-bold">{seeds.length}</p>
      </div>
      <div className="rounded-xl border bg-card p-4">
        <p className="text-xs text-muted-foreground">Nodes</p>
        <p className="text-2xl font-bold">{nodes.length}</p>
      </div>
      <div className="rounded-xl border bg-card p-4">
        <p className="text-xs text-muted-foreground">Content ready</p>
        <p className="text-2xl font-bold">{readyCount} <span className="text-sm text-muted-foreground">({pct}%)</span></p>
      </div>
      <div className="rounded-xl border bg-card p-4">
        <p className="text-xs text-muted-foreground mb-2">Role</p>
        <div className="flex flex-wrap gap-1">
          {Object.entries(roleCounts).sort((a, b) => b[1] - a[1]).map(([role, count]) => (
            <Badge key={role} variant="outline" className="text-[10px] px-1.5 py-0" style={{ borderColor: ROLE_COLORS[role] || "#666", color: ROLE_COLORS[role] || "#666" }}>
              {ROLE_LABELS[role] || role}: {count}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
}
